import React,{useRef,useState,useEffect} from 'react';
import MainSection from './sections/mainSection';
import { Slide} from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import LoadingPage from '../../LocationPage/LoadingPage';
import 'animate.css';
import Footer from './Footer';
const MainPage = ({data})=>{
    const slideRef = useRef(null)
    const latitude = data.latitude;
    const longitude = data.longitude;
    const [apiData,setApiData]=useState(null)
    const [apiData2,setApiData2]=useState(null)
    const [btn,setBtn]=useState({
        first:true,
        second:false,
        third:false,
        fourth:false,
        fifth:false
    })
const btnChange =(newIndex)=>{
    if(newIndex===0){setBtn({
        first:true,
        second:false,
        third:false,
        fourth:false,
        fifth:false
    })}

    else if(newIndex===1){setBtn({
        first:false,
        second:true,
        third:false,
        fourth:false,
        fifth:false
    })}

    else if(newIndex===2){setBtn({
        first:false,
        second:false,
        third:true,
        fourth:false,
        fifth:false
    })}

    else if(newIndex===3){setBtn({
        first:false,
        second:false,
        third:false,
        fourth:true,
        fifth:false
    })}

    else if(newIndex===4){setBtn({
        first:false,
        second:false,
        third:false,
        fourth:false,
        fifth:true
    })}
}
// eslint-disable-next-line
useEffect(()=>{
   FristApiCall();
   SecondApiCall();
// eslint-disable-next-line
},[])
    
   const FristApiCall = async ()=>{
    // const options1 = {
    //     method: 'GET',
    //     headers: {
    //         'X-RapidAPI-Key': '27aa778a47mshe3bf01e5e987df7p106977jsnd273717f21f3',
    //         'X-RapidAPI-Host': 'weatherbit-v1-mashape.p.rapidapi.com'
    //     }
    // };
    const options2 = {
        method: 'GET',
        headers: {
            'X-RapidAPI-Key': 'b9f83d7167msh4a6cafee97217a8p1e3ee0jsnaa8e60bad932',
            'X-RapidAPI-Host': 'weatherbit-v1-mashape.p.rapidapi.com'
        }
    };
    const res = await fetch(`https://weatherbit-v1-mashape.p.rapidapi.com/forecast/3hourly?lat=${latitude}&lon=${longitude}`, options2)
    const data = await res.json();
    setApiData(data)
   }
   

   const SecondApiCall = async ()=>{
        const url1=`https://api.openweathermap.org/data/2.5/forecast?lat=${latitude}&lon=${longitude}&appid=a105b5a3118c394a934559bc376eedc1&units=metric`;
        const res = await fetch(url1)
        const data = await res.json();
        setApiData2(data)
   }

    
   
   
   
   
   if(apiData && apiData2){


    const filterDateDay = ()=>{
        const rawData_date = apiData.data.map((data) => {
            return data.datetime
          })
          //=> all dates in 40 objets
          const realData_date = rawData_date.map((Data) => {
            return{ 
              day: Data.slice(8, -3),
              month:Data.slice(5,-6)
            }
          })
          //=>removed last 3 character that told time
          const filteredDate = []
          for (var i = 0; i <= 39; i = i + 8) {
          
            filteredDate.push(realData_date[i])
          };
          return filteredDate
    }

    const timeConverter = (givenData) => {
        let unix_timestamp = givenData
        // Create a new JavaScript Date object based on the timestamp
        // multiplied by 1000 so that the argument is in milliseconds, not seconds.
        var date = new Date(unix_timestamp * 1000);
        // Hours part from the timestamp
        var hours = date.getHours();
        // Minutes part from the timestamp
        var minutes = "0" + date.getMinutes();
        // Seconds part from the timestamp
        var seconds = "0" + date.getSeconds();
      
        // Will display time in 10:30:23 format
        var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
      
        return formattedTime;
      }
      
      
      
      
      
      const sunrise = timeConverter(apiData2.city.sunrise)
      const sunset = timeConverter(apiData2.city.sunset)
      const rawData_total = apiData2.list.map((tempData) => {
        return (
          {
            mainCard: {
              temp: tempData.main.temp,
      
              secondaryCard: tempData.weather.map((d) => {
                return {
                  icon: d.icon,
                  mainTitle: d.main,
                  description: d.description,
                }
              })
            },
            sideBar: {
              pressure: tempData.main.pressure,
              humidity: tempData.main.humidity,
              windSpeed: tempData.wind.speed,
              sunrise: sunrise,
              sunset: sunset,
              cloud: tempData.clouds.all
            }
      
          }
        )
      })
      const FilteredData_total = []
      for (var j = 0; j <= 39; j = j + 8) {
        FilteredData_total.push(rawData_total[j])
      }
    //   console.log(FilteredData_total)
      
      //-> filtered data for slider
      
      
      const rawData_date = apiData.data.map((data) => {
        return data.datetime
      })
      //=> all dates in 40 objets
      const realData_date = rawData_date.map((Data) => {
        return Data.slice(0, -3)
      })
      //=>removed last 3 character that told time
      const filteredDate = []
      for (var i = 0; i <= 39; i = i + 8) {
      
        filteredDate.push(realData_date[i])
      };
      //filtered the 5 days date I require
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const dayForBtn = filteredDate.map((date) => {
        var dataString = date
        var d = new Date(dataString);
        return days[d.getDay()]
      })

    //   //converted all the 5 dates to days
      
    //   console.log(dayForBtn)
    //   //output = >
      
      const nonMapedData = {
        cityName: apiData.city_name,
        day: dayForBtn,
        date: filterDateDay(),
      }
  
      //->nonMapedData for constant dynamic data
// eslint-disable-next-line
   const date =   nonMapedData.date.map((d)=>{
        if(d.month==='01'){
            return d.day+" Jan"
        }
        else if(d.month==='02'){
            return d.day+" Feb"
        }
        else if(d.month==='03'){
            return d.day+" Mar"
        }
        else if(d.month==='04'){
            return d.day+" Apr"
        }
        else if(d.month==='05'){
            return d.day+" May"
        }
        else if(d.month==='06'){
            return d.day+" Jun"
        }
        else if(d.month==='07'){
            return d.day+" July"
        }
        else if(d.month==='08'){
            return d.day+" Aug"
        }
        else if(d.month==='09'){
            return d.day+" Sep"
        }
        else if(d.month==='10'){
            return d.day+" Oct"
        }
        else if(d.month==='11'){
            return d.day+" Nov"
        }
        else if(d.month==='12'){
            return d.day+" Dec"
        }
        
      })




    return(
        
        
        <section className="text-cusWhite font-poppins bg-cusDarkBlack h-full">
            <div className='transition-all animate__animated animate__fadeInUp animate__slow '>
            <div className="container  mx-auto flex px-0 py-0 pt-3 items-center justify-center flex-col">
            <div className="text-center lg:w-2/3 w-auto">
      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-gray-900">{nonMapedData.cityName}</h1></div>
        </div>
        <Slide indicators={true} ref={slideRef} duration={60000} transitionDuration={2000} defaultIndex={0} easing="cubic" onChange={(oldIndex,newIndex)=>{
            btnChange(newIndex);
        }}>
 
        {
            FilteredData_total.map((totalData)=>{
                return <MainSection totalData={totalData}/>
            })
        }
    
       
       
  
        </Slide>

        <div className="flex items-center justify-center font-poppins">
            <div className="grid gap-5 mt-2 md:grid-cols-5 justify-center grid-cols-3">
                <div className="w-full max-w-xs text-center mb-7 ">
                    <button value="0" onClick={(event) => {
                          setBtn({
                            first:true,
                            second:false,
                            third:false,
                            fourth:false,
                            fifth:false
                            
                        })
                        slideRef.current.goTo(parseInt(event.currentTarget.value))}} act>
                    <div className={`m-3 bg-cusLightBlack w-20 h-16 rounded-lg ${btn.first?"transition-all duration-700 scale-125":"transition-all duration-700"}`}>
                    <h3 className="text-lg font-medium text-cusLightWhite dark:text-gray-200   pt-1">{nonMapedData.day[0]}</h3>
                        <span className="mt-1 font-poppinsLight text-cusLightWhite dark:text-gray-300 text-sm">{date[0]}</span>
                    </div>
                    </button>
                </div>

                <div className="w-full max-w-xs text-center">
                    <button value="1" onClick={(event) =>{
                        setBtn({
                            first:false,
                            second:true,
                            third:false,
                            fourth:false,
                            fifth:false
                            
                        })
                        slideRef.current.goTo(parseInt(event.currentTarget.value))}}>

                    <div className={`m-3 bg-cusLightBlack w-20 h-16 rounded-lg ${btn.second?"transition-all duration-700 scale-125":"transition-all duration-700"}`}>
                    <h3 className="text-lg font-medium text-cusLightWhite dark:text-gray-200   pt-1">{nonMapedData.day[1]}</h3>
                        <span className="mt-1 font-poppinsLight text-cusLightWhite dark:text-gray-300 text-sm">{date[1]}</span>
                    </div>
                    </button>
                </div>

                <div className="w-full max-w-xs text-center">
                    <button value="2" onClick={(event) =>{ 
                          setBtn({
                            first:false,
                            second:false,
                            third:true,
                            fourth:false,
                            fifth:false
                            
                        })
                        slideRef.current.goTo(parseInt(event.currentTarget.value))}}>

                    <div className={`m-3  bg-cusLightBlack w-20 h-16 rounded-lg ${btn.third?"transition-all duration-700 scale-125":"transition-all duration-700"}`}>
                    <h3 className="text-lg font-medium text-cusLightWhite dark:text-gray-200   pt-1">{nonMapedData.day[2]}</h3>
                        <span className="mt-1 font-poppinsLight text-cusLightWhite dark:text-gray-300 text-sm">{date[2]}</span>
                    </div>
                    </button>
                </div>

                <div className="w-full max-w-xs text-center">

                    <button value="3" onClick={(event) =>{ 
                          setBtn({
                            first:false,
                            second:false,
                            third:false,
                            fourth:true,
                            fifth:false
                            
                        })
                        slideRef.current.goTo(parseInt(event.currentTarget.value))}}>

                    <div className={`md:m-3 lg:m-3 xl:m-3 ml-20 mb-3 bg-cusLightBlack w-20 h-16 rounded-lg ${btn.fourth?"transition-all duration-700 scale-125":"transition-all duration-700"}`}>
                    <h3 className="text-lg font-medium text-cusLightWhite dark:text-gray-200   pt-1">{nonMapedData.day[3]}</h3>
                        <span className="mt-1 font-poppinsLight text-cusLightWhite dark:text-gray-300 text-sm">{date[3]}</span>
                    </div>
                    </button>
                </div>
                <div className="w-full max-w-xs text-center">
                    <button value="4" onClick={(event) =>{ 
                          setBtn({
                            first:false,
                            second:false,
                            third:false,
                            fourth:false,
                            fifth:true
                            
                        })
                        slideRef.current.goTo(parseInt(event.currentTarget.value))}}>

                    <div className={`md:m-3 lg:m-3 xl:m-3 ml-20 mb-3 bg-cusLightBlack w-20 h-16 rounded-lg ${btn.fifth?"transition-all duration-700 scale-125":"transition-all duration-700"}`}>
                    <h3 className="text-lg font-medium text-cusLightWhite dark:text-gray-200   pt-1">{nonMapedData.day[4]}</h3>
                        <span className="mt-1 font-poppinsLight text-cusLightWhite dark:text-gray-300 text-sm">{date[4]}</span>
                    </div>
                    </button>
                </div>
            </div>
        </div>
        </div>
        <Footer/>
    </section>
    )}
    else{
        return(<>
            <LoadingPage/>
            </>
        )
    }
}
export default MainPage